import { OnlineUserPrivilege } from 'typings/onlineUser'

export const getInitialUserPrivilegeInfo = (
  isAddtionalPrivilege = false
): OnlineUserPrivilege => {
  let initPrivilegeInfo: OnlineUserPrivilege = {
    onlineAccessToEServicePlatform: false,
    payOnline: false,
    updateAddressAndPhone: false,
    requestIncreaseToCreditLine: false,
    requestCopiesOfFormsForTaxExemptPurchases: false,
    reportMissingCreditOrReturn: false,
    closeSecondaryAccount: false,
    disputeAnInvoice: false,
    requestCopiesOfBillingStatements: false,
    requestCopiesOfReceiptsWithBuyerSignature: false,
    copyOfItemizedInvoices: false,
    missingPayment: false,
    viewAndAddAuthorizedBuyers: false,
    viewAndRemoveAuthorizedBuyers: false,
    updatePOJobName: false
  }
  if (isAddtionalPrivilege) {
    initPrivilegeInfo = {
      ...initPrivilegeInfo,
      requestAdditionalCards: false,
      reportLostStolen: false,
      editUserInfo: false
    }
  }
  return initPrivilegeInfo
}

export const initialOptionValues = { label: '', value: '' }
